import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { find } from 'lodash';

import api from 'core/utils/api';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  deviceId: PropTypes.string,
  params: PropTypes.object,
};

const defaultProps = {
  onBlur: () => {},
  deviceId: null,
  params: null,
};

export const renderLabel = (device) => {
  const { manufacturer, deviceable, label } = device;
  const { serial_number } = deviceable;
  let name = '';
  if (label) { name += `(${label}) `; }
  name += `${manufacturer} (${serial_number})`;
  return name;
};

class DeviceLookup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      device: null,
      devices: [],
    };

    this.mounted = false;

    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setInitialDevice = this.setInitialDevice.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    const { params } = this.props;

    if (this.mounted) {
      api
        .get('/devices', {
          params: Object.assign({ per_page: 100 }, params),
        })
        .then((res) => {
          if (this.mounted) {
            this.setState({
              devices: res.data.devices,
              loading: false,
            }, () => {
              this.setInitialDevice();
            });
          }
        });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  setInitialDevice() {
    const { deviceId } = this.props;
    if (!deviceId) { return; }

    const found = find(this.state.devices, { id: deviceId });
    this.setState({ device: found });
  }

  handleChange(device) {
    this.setState({ device }, () => {
      this.props.onChange(device);
    });
  }

  handleBlur() {
    const { onBlur } = this.props;
    if (onBlur) { onBlur(); }
  }

  render() {
    const { loading, devices, device } = this.state;

    return (
      <Select
        value={device}
        isLoading={loading}
        isClearable
        options={devices}
        onChange={this.handleChange}
        getOptionLabel={option => renderLabel(option)}
        getOptionValue={option => option.id}
        onBlur={this.handleBlur}
      />
    );
  }
}

DeviceLookup.propTypes = propTypes;
DeviceLookup.defaultProps = defaultProps;

export default DeviceLookup;



// WEBPACK FOOTER //
// ./src/components/DeviceLookup.js